import { Stack } from "@mui/material";
import { FC, useState } from "react";
import { useDidMount } from "rooks";
import { GridApi } from "ag-grid-community";
import { PageHeader } from "@/components/pages/common/PageHeader";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { getAiKubernetesRecommendationsThunk } from "@/store/ai-kubernetes-recommendations/thunks/getAiKubernetesRecommendationsThunk";
import { getAiKubernetesRecommendationsLoadingSelector } from "@/store/ai-kubernetes-recommendations/selectors/getAiKubernetesRecommendationsLoadingSelector";
import { AiKubernetesRecommendationsMetadata } from "@/components/pages/ai-kubernetes-recommendations/components/AiKubernetesRecommendationsMetadata";
import { AiKubernetesRecommendationsGrid } from "@/components/pages/ai-kubernetes-recommendations/components/AiKubernetesRecommendationsGrid";
import { AiKubernetesRecommendationsTableToolbar } from "@/components/pages/ai-kubernetes-recommendations/components/AiKubernetesRecommendationsTableToolbar";

export const AiKubernetesRecommendations: FC = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(getAiKubernetesRecommendationsLoadingSelector);
  const [gridApi, setGridApi] = useState<GridApi | null>(null);

  useDidMount(() => {
    dispatch(getAiKubernetesRecommendationsThunk());
  });

  return (
    <Stack bgcolor="white" height="100%">
      <PageHeader
        sticky
        title="AI Kubernetes Recommendations"
        loading={loading}
      />

      <AiKubernetesRecommendationsMetadata gridApi={gridApi} />

      <AiKubernetesRecommendationsTableToolbar gridApi={gridApi} />

      <AiKubernetesRecommendationsGrid
        setGridApi={setGridApi}
        gridApi={gridApi}
      />
    </Stack>
  );
};
